import React  from "react";
import PropTypes from 'prop-types'
import { Card, CardHeader, CardText } from "material-ui/Card";

export const RenderCard = (props) => {
  return (
    <Card style={{ marginBottom: 16 }}>
      {(props.title !== '') && <CardHeader
        title={props.title}
        subtitle=""
      />}
      <CardText>
        {props.children}
      </CardText>
    </Card>
  )
};

RenderCard.propTypes = {
  children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
  ]).isRequired
}


// WEBPACK FOOTER //
// ./src/products/createfield/ProductField.js